import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzResultModule } from 'ng-zorro-antd/result';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
@NgModule({
  exports: [
    NzSwitchModule,
    NzRadioModule,
    NzButtonModule,
    NzGridModule,
    NzProgressModule,
    NzIconModule,
    NzPaginationModule,
    NzModalModule,
    NzDropDownModule,
    NzDatePickerModule,
    NzUploadModule,
    NzInputModule,
    NzSelectModule,
    NzLayoutModule,
    NzAutocompleteModule,
    NzPopoverModule,
    NzResultModule,
    NzCardModule,
    NzAvatarModule,
    NzBadgeModule,
    NzFormModule,
    NzMessageModule,
    NzTabsModule,
    NzDrawerModule,
    NzPopconfirmModule,
    NzSpinModule,
    NzDividerModule,
    NzToolTipModule,
    NzCheckboxModule,
  ],
  imports: [
    CommonModule,
    NzSwitchModule,
    NzRadioModule,
    NzButtonModule,
    NzGridModule,
    NzProgressModule,
    NzIconModule,
    NzPaginationModule,
    NzModalModule,
    NzDropDownModule,
    NzDatePickerModule,
    NzUploadModule,
    NzInputModule,
    NzSelectModule,
    NzLayoutModule,
    NzAutocompleteModule,
    NzPopoverModule,
    NzResultModule,
    NzCardModule,
    NzTabsModule,
    NzDrawerModule,
    NzPopconfirmModule,
    NzSpinModule,
    NzDividerModule,
    NzToolTipModule,
    NzCheckboxModule,
  ],
})
export class NzModule {}
